import React, { createContext, useState } from 'react';

import { useStopVideos } from '@/hooks/useStopVideos';

import { Modal } from '@/components/global/Modal';

import { TModalProps, TModalState } from './types';

const initialValue = {
  isShow: false,
  content: {
    title: '',
    text: '',
  },
} as TModalState;

export const ModalContext = createContext(initialValue);

export const ModalProvider = ({
  theme,
  children,
}: TModalProps): JSX.Element | null => {
  const [status, setStatus] = useState(false);
  const [content, setContentModal] = useState(initialValue.content);
  const [recommendationId, setRecommendationId] = useState<string>('');
  const { stopVideos } = useStopVideos();

  const onClose = () => {
    setStatus(false);
    stopVideos();
  };

  const setContent = (title: string, text: string) => {
    setContentModal(() => ({
      title,
      text,
    }));
  };

  return (
    <ModalContext.Provider
      value={{
        isShow: status,
        setShow: setStatus,
        content,
        setContent,
        recommendationId,
        setRecommendationId,
      }}
    >
      <>
        {children}
        <Modal
          id="rcs-modal"
          title={content.title}
          text={content.text}
          show={status}
          theme={theme}
          onClose={onClose}
          recommendationId={recommendationId}
        />
      </>
    </ModalContext.Provider>
  );
};
